<div class="view-invoice-page" fxLayout="column" fxLayoutAlign="center">

  <mat-card appearance="outlined" *ngIf="invoice" class="">
    <mat-card-content>

      <form #invoiceForm="ngForm">

        <div fxLayout="row wrap" fxLayoutGap="10px" fxLayoutGap.gt-sm="16px">
          <div fxFlex="100" fxFlex.gt-sm="48">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'INVOICE_NUMBER' | translate}}</mat-label>
              <input matInput [(ngModel)]="invoice.invoiceNumber" name="invoiceNumber" #name="ngModel" id="invoiceNumber" placeholder="{{'INVOICE_NUMBER' | translate}}" style="width: 100%" required>
            </mat-form-field>
          </div>
          <div fxFlex="48" fxFlex.gt-sm="24">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'INVOICE_DATE' | translate}}</mat-label>
              <input matInput [(ngModel)]="invoice.invoiceDate" name="invoiceDate" (focus)="picker.open()" and (click)="picker.open()" #name="ngModel" [matDatepicker]="picker" placeholder="{{'INVOICE_DATE' | translate}}" required>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div fxFlex="48" fxFlex.gt-sm="24">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'DUE_DATE' | translate}}</mat-label>
              <input matInput [(ngModel)]="invoice.dueDate" name="dueDate" (focus)="dueDatePicker.open()" and (click)="dueDatePicker.open()" #name="ngModel" [matDatepicker]="dueDatePicker" placeholder="{{'DUE_DATE' | translate}}" required>
              <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #dueDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </form>

    </mat-card-content>

    <mat-card-content>
      <h4 class="mb-2">Products <button style="float: right;" mat-flat-button color="accent" (click)="createInvoiceRow()">{{'ADD_NEW_PRODUCT' | translate}}</button></h4>
      <ngx-datatable class="material" [rows]="invoice.invoiceProductRows" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="0" [rowHeight]="'auto'" [scrollbarH]="true">

        <ngx-datatable-column name="{{'DESCRIPTION' | translate}}" [width]="150">
          <ng-template ngx-datatable-cell-template let-row="row">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>{{'PRODUCT' | translate}}</mat-label>
              <mat-select placeholder="{{'SELECT_PRODUCT' | translate}}" [(ngModel)]="row.productNumber" required (selectionChange)="productChanged(row)" name="product" #product="ngModel">
                <ng-container *ngIf="!shopConfig?.enableStockControl">
                  <mat-option *ngFor="let product of products | productFilter: searchProduct" [value]="product.id">
                    {{ product.productName }}
                  </mat-option>
                </ng-container>
                <ng-container *ngIf="shopConfig?.enableStockControl">
                  <mat-option *ngFor="let product of products | productFilter: searchProduct" [value]="product.id" [disabled]="product?.stockAvailable <= 0">
                    {{ product.productName }} <span *ngIf="product?.stockAvailable <= 0" class="mat-text-red">({{'OUT_OF_STOCK' | translate}})</span>
                  </mat-option>
                </ng-container>
              </mat-select>
              <mat-error *ngIf="product.hasError('required')">
                {{'PRODUCT_IS' | translate}} <strong>{{'REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="{{'UNIT_PRICE' | translate}}" [width]="120">
          <ng-template ngx-datatable-cell-template let-row="row">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'UNIT_PRICE' | translate}}</mat-label>
              <input matInput type="text" appNumberOnly [decimalPoints]="2" placeholder="{{'UNIT_PRICE' | translate}}" name="unitPrice" #unitPrice="ngModel" (change)="updateInvoice()" [(ngModel)]="row.unitPrice" id="unitPrice" required>
              <mat-error *ngIf="unitPrice.hasError('required')">
                {{'UNIT_PRICE_IS' | translate}} <strong>{{'REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="{{'TAX_RATE' | translate}}" [width]="100">
          <ng-template ngx-datatable-cell-template let-row="row">
            <strong>{{row.tax}}</strong>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="{{'QUANTITY' | translate}}" [width]="120">
          <ng-template ngx-datatable-cell-template let-row="row">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'QUANTITY' | translate}}</mat-label>
              <input matInput placeholder="{{'QUANTITY' | translate}}" type="text" appNumberOnly name="quantity" #quantity="ngModel" (change)="updateInvoice()" [(ngModel)]="row.quantity" id="quantity" required>
              <mat-error *ngIf="quantity.hasError('required')">
                {{'QUNATITY_IS' | translate}} <strong>{{'REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="{{'AMOUNT' | translate}}" [width]="120">
          <ng-template ngx-datatable-cell-template let-row="row">
            <strong>{{ row.grossPrice | currency:currencyCode:'symbol'}}</strong>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="{{'EDIT' | translate}}" [width]="100">
          <!-- <ng-template ngx-datatable-header-template>
            <button mat-mini-fab color="accent" style="top: -10px !important;" type="button"
              (click)="createInvoiceRow()">
              <mat-icon>add</mat-icon>
            </button>
          </ng-template> -->
          <ng-template ngx-datatable-cell-template let-row="row">

            <!--
          <button (click)="editRow(row)" class="ml-xs mat-icon-button" mat-icon-button="">
                <span class="mat-button-wrapper">
                    <mat-icon role="img" class="demo-toolbar-icon" aria-label="edit">edit</mat-icon>
                </span>
            <div class="mat-button-ripple mat-ripple mat-button-ripple-round" mat-ripple=""></div>
            <div class="mat-button-focus-overlay"></div>
          </button>
          -->
            <button (click)="deleteRow(row)" class="ml-xs mat-icon-button" mat-icon-button="">
              <span class="mat-button-wrapper">
                <mat-icon role="img" class="demo-toolbar-icon" aria-label="delete">delete</mat-icon>
              </span>
              <div class="mat-button-ripple mat-ripple mat-button-ripple-round" mat-ripple=""></div>
              <div class="mat-button-focus-overlay"></div>
            </button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </mat-card-content>


    <hr>
    <mat-card-content *ngIf="invoice" class="mdc-mb-1">
      <div fxLayout="row" fxLayoutWrap="wrap">
        <div fxFlex.gt-sm="25" fxFlex.gt-xs="50" fxFlex="100" class="mt-1 mdc-mb-1">
          <h6 class="text-uppercase text-md ma-0 text-bold">{{'SUBTOTAL' | translate}}</h6>
          <h3 class="ma-0">{{invoice.subTotal | currency:currencyCode:'symbol'}}</h3>
        </div>
        <div fxFlex.gt-sm="25" fxFlex.gt-xs="50" fxFlex="100" class="mt-1 mdc-mb-1">
          <h6 class="text-uppercase text-md ma-0 text-bold">{{'TAX' | translate}}</h6>
          <h3 class="ma-0">{{invoice.tax | currency:currencyCode:'symbol'}}</h3>
        </div>
        <div fxFlex.gt-sm="25" fxFlex.gt-xs="50" fxFlex="100" class="mt-1 mdc-mb-1">
          <h6 class="text-uppercase text-md ma-0 text-bold">{{'DISCOUNT' | translate}}</h6>
          <h3 class="ma-0">{{0.00|currency:currencyCode:'symbol'}}</h3>
        </div>
        <div fxFlex.gt-sm="25" fxFlex.gt-xs="50" fxFlex="100" class="mt-1 mdc-mb-1 text-xs-left text-sm-right">
          <h6 class="text-uppercase text-sm ma-0 text-bold">{{'TOTAL' | translate}}</h6>
          <h3 class="ma-0 mat-text-accent">{{ invoice.total | currency:currencyCode:'symbol'}}</h3>
        </div>
      </div>
    </mat-card-content>
    <hr>

    <mat-card-content>
      <p class="text-md">
        <strong>
          {{'PAYMENT_TERMS_AND_POLICIES' | translate}}
        </strong>
        {{invoice.invoiceTerms}}
      </p>
    </mat-card-content>

    <hr>
    <mat-card-content class="py-1">

      <button mat-raised-button color="accent" *ngIf="!invoice.id" (click)="addInvoice()" [disabled]="!invoiceForm.form.valid" disabled="disabled">{{'CREATE_INVOICE' | translate}}
      </button>

      &nbsp;

      <button mat-raised-button color="accent" *ngIf="invoice.id" (click)="viewInvoice()" [disabled]="!invoiceForm.form.valid" disabled="disabled">{{'VIEW_INVOICE' | translate}}
      </button>

    </mat-card-content>
  </mat-card>

</div>